import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { Section } from '../styles/elements'
import ampImg from '../static/images/backgrounds/amplifier.png'
import fullAmpImg from '../static/images/backgrounds/amplifier2.png'
import { colors, media } from '../styles/vars'
import SectionHeading from '../components/SectionHeading'
import playImg from '../static/images/icons/big_play.png'
import videoBg from '../static/images/backgrounds/video_pic.jpg'
import { fpInit } from '../player'
import { ArticlesApi } from '../api'
import sectionBg from '../static/images/backgrounds/video_bg.jpg'
import lineBg from '../static/images/backgrounds/line.png'

const Container = styled(Section) `
background-color:${colors.black};

${media.desktop`
height:410px;
`}
`

const FloatingBackground = styled.div`
display:none;
${
    media.desktop`
    display:block;
    position:absolute;
    left:0;
    right:0;
    bottom:0;
    top:-180px;
    background-repeat:no-repeat;
    background-image:url(${sectionBg});
    background-position:center top;
    background-size:cover;
    opacity:.6;
    `
    }
`


const AmpContainer = styled.div`
background-repeat:no-repeat;
background-image:url(${ampImg});
background-size:contain;
background-position:center;
padding-bottom:139%;
position:relative;

${
    media.desktop`
    padding:0;
    background-image:url(${fullAmpImg});
    width:980px;
    height:700px;
    margin:0 auto;
    transform:translate3d(-60px,-290px,0);
    `
    }
`

const ampContentCss = css`
height:331px;
width:575px;
max-width:1020px;
transform:translate3d(2px,-70px,0);
margin:0 auto;
`
const AmpMask = styled.div`
position:absolute;
bottom:0;
left:0;
right:0;
transform:translate3d(0,-6.3vw,0);
text-align:center;
height:60.4vw;
background-repeat:no-repeat;
background-size:cover;
background-position:center;
background-image:url(${videoBg});
z-index:1;
transition:visibility .4s, opacity .4s;
cursor:pointer;
${
    media.desktop`
    ${ampContentCss}
    `
    }
`
const StyledAmpMask = styled(AmpMask) `
visibility:${props => props.shown ? 'visible' : 'hidden'};
opacity:${props => props.shown ? '1' : '0'};
`
const HeadingContainer = styled.div`
margin-top:5vw;
h2{
    font-size:5vw !important;
}
${
    media.desktop`
    margin-top:20px;
    h2{
        font-size:3rem !important;
    }
    `
    }
`
const PlayContainer = styled.div`
margin-top:10vw;
${
    media.desktop`
    margin:0;
    height:100%;
    width:100%;
    position:absolute;
    top:0;
    left:0;
    `
    }
`
const PlayImage = styled.img`
max-width:20%;
margin:0 auto;
${
    media.desktop`
     margin:auto;
     width:120px;
     height:120px;
     max-width:initial;
     position:absolute;
     bottom:0;
     top:0;
     right:0;
     left:0;
    `
    }
`

const CreditText = styled.p`
color:${colors.lightblue};
font-size:4vw;
position:absolute;
bottom:1.2vw;
left:0;
right:0;
text-align:center;
${media.desktop`
font-size:2rem;
bottom:31px;
`}
`
const CreditValue = styled.label`
color:${colors.white};
display:inline-block;
margin:0 .9vw;
${media.desktop`
margin:0 7px;
`}
`
const VideoWrapper = styled.div`
position:absolute;
bottom:8vw;
left:0;
right:0;
// transform:translate3d(0, -8vw, 0);

.flowplayer.is-ready:not(.is-poster){
    background-color:${colors.black};
}

${
    media.desktop`
    ${ampContentCss}
    bottom:0;
    `
    }
`
const StyledVideo = styled.div`
direction:ltr;
`
const SeperationLine = styled.div`
height:6px;
background-image:url(${lineBg});
position:absolute;
bottom:0;
width:100%;
transform: translate3d(0, 2.5px, 0);
${
    media.desktop`
    height:7px;
    transform:none;
    `
    }
`
class AmpSection extends Component {
    constructor() {
        super();
        this.handleMaskClick = this.handleMaskClick.bind(this);
        this.state = {}
    }
    async componentDidMount() {
        const videoDetails = await ArticlesApi.getVideoDetails('184370');
        this.video = fpInit(
            Object.assign({}, videoDetails[0], { selector: "#introVideo" }),
            () => {
                this.video.quality(1);
            }
        );
        // this.video.on('cuepoint', () => {
        //     this.video.on('pause', () => {
        //         this.setState({
        //             maskClicked: false
        //         });
        //     });
        // });
    }
    componentWillUnmount() {
        if (this.video)
            this.video.unload();
    }
    handleMaskClick() {
        this.setState({
            maskClicked: true
        });

        this.video[this.video.splash ? 'load' : 'play']();
    }
    render() {
        return (
            <Container id="ampSection">
                <FloatingBackground />
                <AmpContainer>
                    <VideoWrapper>
                        <StyledVideo id="introVideo"></StyledVideo>
                    </VideoWrapper>
                    <StyledAmpMask
                        shown={!this.state.maskClicked}
                        onClick={this.handleMaskClick}
                    >
                        <HeadingContainer>
                            <SectionHeading
                                titlePrefix="איך זה עובד: "
                                title="שיעור מעשי בדיסטורשן עם הגיטריסט יוסי סאסי"
                                bgColor={colors.darkPurple}
                            />
                        </HeadingContainer>
                        <PlayContainer>
                            <PlayImage src={playImg} />
                        </PlayContainer>
                    </StyledAmpMask>
                    <CreditText>
                        כתב:
                             <CreditValue>עמי פרידמן</CreditValue>
                        צילום:
                             <CreditValue>אורי דוידוביץ'</CreditValue>
                        בימוי ועריכה:
                             <CreditValue>אסף קוזין ובן שפייר</CreditValue>
                    </CreditText>
                </AmpContainer>
                <SeperationLine />
            </Container>
        )
    }
}

export default AmpSection;


// WEBPACK FOOTER //
// ./src/containers/AmpSection.jsx